import React from 'react';
import { PageWrap } from 'components/Containers';
import { Heading, Message } from 'components/Wrapped';
import { withNamespaces } from 'react-i18next';
import { nestedTranslate } from 'utils';
import { ButtonNew, Box } from 'components/Wrapped';

const GeneralError = withNamespaces()(({ t: translate }) => {
  const t = nestedTranslate(translate, 'errorPages');

  return (
    <PageWrap justify="center" align="center" background="#000D14">
      <Message background="#000D14">
        <Box
          pad="none"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Heading level={1} style={{ textAlign: 'center' }}>
            {t('generalError')}
          </Heading>

          <ButtonNew
            theme={'green'}
            label={translate('buttons.reload')}
            width="200px"
            height="40px"
            onClick={() => window.location.replace('/trade')}
          />
        </Box>
      </Message>
    </PageWrap>
  );
});

export default GeneralError;
